import { resolveStoreCategory } from "./storeCategory"

type ExperienceKind = "general" | "car" | "property" | "gym" | "service" | "fashion"

export function getStoreExperience(storeOrCategory: any) {
  const category = resolveStoreCategory(storeOrCategory)

  const shared = {
    shell: {
      sidebarWidthClass: "lg:ml-72",
    },
  }

  if (category === "CAR_BOUTIQUE") {
    return {
      ...shared,
      kind: "car" as ExperienceKind,
      category,
      name: "Auto",
      badge: "Auto Collection",
      inventorySingular: "vehicule",
      inventoryPlural: "vehicules",
      stockSectionLabel: "Parc auto",
      salesSectionLabel: "Transactions",
      clientsSectionLabel: "Prospects",
      searchPlaceholder: "Rechercher vehicule, reference, client…",
      sidebar: {
        bgClass: "bg-gradient-to-b from-slate-950 via-slate-900 to-orange-950",
        borderClass: "border-white/10",
        sectionClass: "text-orange-300/70",
        activeClass: "bg-white text-slate-950 shadow-lg",
        inactiveClass: "text-slate-200 hover:bg-white/10 hover:text-white",
        footerClass: "text-slate-400",
      },
      layout: {
        appBgClass: "bg-[radial-gradient(circle_at_top,_rgba(251,146,60,0.16),_transparent_35%),linear-gradient(180deg,_#fff7ed_0%,_#f8fafc_48%,_#f1f5f9_100%)]",
        mainBgClass: "bg-transparent",
      },
      topbar: {
        headerClass: "bg-white/78 border-slate-200",
        badgeClass: "bg-orange-100 text-orange-800 border-orange-200",
        searchIdleClass: "bg-slate-100 text-slate-500",
        searchActiveClass: "bg-orange-50 text-orange-600",
        searchRingClass: "border-orange-300 shadow-[0_0_0_4px_rgba(251,146,60,0.12)]",
      },
      stock: {
        heroBadge: "Garage Control",
        heroTitle: "Parc automobile",
        heroSubtitle: "Pilotez vos vehicules, loyers journaliers, disponibilites et references depuis une vue plus premium.",
        heroClass: "from-slate-950 via-slate-900 to-orange-700",
        heroGlowClass: "bg-orange-300/20",
        buttonClass: "bg-orange-500 text-white hover:bg-orange-400",
        secondaryButtonClass: "border-orange-200 bg-orange-50 text-orange-700 hover:bg-orange-100",
        panelClass: "border-orange-100 bg-white/95",
        panelMutedClass: "bg-gradient-to-br from-orange-50 to-white",
        alertClass: "from-orange-500 via-amber-500 to-yellow-500",
        availableStatusClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
        lowStatusClass: "bg-orange-50 text-orange-700 border-orange-200",
        progressClass: "bg-orange-500",
      },
    }
  }

  if (category === "REAL_ESTATE") {
    return {
      ...shared,
      kind: "property" as ExperienceKind,
      category,
      name: "Immobilier",
      badge: "Real Estate Desk",
      inventorySingular: "bien",
      inventoryPlural: "biens",
      stockSectionLabel: "Portefeuille",
      salesSectionLabel: "Opportunites",
      clientsSectionLabel: "Acquereurs",
      searchPlaceholder: "Rechercher bien, quartier, reference…",
      sidebar: {
        bgClass: "bg-gradient-to-b from-emerald-950 via-teal-900 to-cyan-950",
        borderClass: "border-white/10",
        sectionClass: "text-emerald-300/70",
        activeClass: "bg-white text-emerald-950 shadow-lg",
        inactiveClass: "text-emerald-50 hover:bg-white/10 hover:text-white",
        footerClass: "text-emerald-200/70",
      },
      layout: {
        appBgClass: "bg-[radial-gradient(circle_at_top,_rgba(45,212,191,0.14),_transparent_35%),linear-gradient(180deg,_#ecfeff_0%,_#f8fafc_50%,_#f0fdfa_100%)]",
        mainBgClass: "bg-transparent",
      },
      topbar: {
        headerClass: "bg-white/78 border-emerald-100",
        badgeClass: "bg-emerald-100 text-emerald-800 border-emerald-200",
        searchIdleClass: "bg-slate-100 text-slate-500",
        searchActiveClass: "bg-emerald-50 text-emerald-700",
        searchRingClass: "border-emerald-300 shadow-[0_0_0_4px_rgba(16,185,129,0.12)]",
      },
      stock: {
        heroBadge: "Property Flow",
        heroTitle: "Portefeuille immobilier",
        heroSubtitle: "Mettez en avant les biens, gerez les disponibilites et alternez facilement entre vue carte et vue tableau.",
        heroClass: "from-emerald-900 via-teal-700 to-cyan-700",
        heroGlowClass: "bg-emerald-200/20",
        buttonClass: "bg-emerald-500 text-white hover:bg-emerald-400",
        secondaryButtonClass: "border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100",
        panelClass: "border-emerald-100 bg-white/95",
        panelMutedClass: "bg-gradient-to-br from-emerald-50 to-white",
        alertClass: "from-emerald-500 via-teal-500 to-cyan-500",
        availableStatusClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
        lowStatusClass: "bg-amber-50 text-amber-700 border-amber-200",
        progressClass: "bg-emerald-500",
      },
    }
  }

  if (category === "GYM") {
    return {
      ...shared,
      kind: "gym" as ExperienceKind,
      category,
      name: "Fitness",
      badge: "Fitness Control",
      inventorySingular: "article fitness",
      inventoryPlural: "articles fitness",
      stockSectionLabel: "Espace fitness",
      salesSectionLabel: "Abonnements & ventes",
      clientsSectionLabel: "Membres",
      searchPlaceholder: "Rechercher membre, abonnement, supplement…",
      sidebar: {
        bgClass: "bg-gradient-to-b from-slate-950 via-emerald-950 to-lime-950",
        borderClass: "border-white/10",
        sectionClass: "text-lime-300/70",
        activeClass: "bg-white text-emerald-950 shadow-lg",
        inactiveClass: "text-lime-50 hover:bg-white/10 hover:text-white",
        footerClass: "text-lime-200/70",
      },
      layout: {
        appBgClass: "bg-[radial-gradient(circle_at_top,_rgba(132,204,22,0.16),_transparent_35%),linear-gradient(180deg,_#f7fee7_0%,_#f8fafc_45%,_#ecfccb_100%)]",
        mainBgClass: "bg-transparent",
      },
      topbar: {
        headerClass: "bg-white/80 border-lime-100",
        badgeClass: "bg-lime-100 text-lime-900 border-lime-200",
        searchIdleClass: "bg-slate-100 text-slate-500",
        searchActiveClass: "bg-lime-50 text-lime-700",
        searchRingClass: "border-lime-300 shadow-[0_0_0_4px_rgba(132,204,22,0.14)]",
      },
      stock: {
        heroBadge: "Gym Ops",
        heroTitle: "Espace fitness",
        heroSubtitle: "Pilotez supplements, accessoires, packs coaching et references vendues depuis une interface plus fitness.",
        heroClass: "from-slate-950 via-emerald-800 to-lime-600",
        heroGlowClass: "bg-lime-300/20",
        buttonClass: "bg-lime-400 text-slate-950 hover:bg-lime-300",
        secondaryButtonClass: "border-lime-200 bg-lime-50 text-lime-800 hover:bg-lime-100",
        panelClass: "border-lime-100 bg-white/95",
        panelMutedClass: "bg-gradient-to-br from-lime-50 to-white",
        alertClass: "from-lime-500 via-emerald-500 to-teal-500",
        availableStatusClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
        lowStatusClass: "bg-amber-50 text-amber-700 border-amber-200",
        progressClass: "bg-lime-500",
      },
    }
  }

  if (category === "SERVICE_BUSINESS") {
    return {
      ...shared,
      kind: "service" as ExperienceKind,
      category,
      name: "Services",
      badge: "Service Studio",
      inventorySingular: "service",
      inventoryPlural: "services",
      stockSectionLabel: "Catalogue services",
      salesSectionLabel: "Demandes & clients",
      clientsSectionLabel: "Clients & prospects",
      searchPlaceholder: "Rechercher service, devis, client…",
      sidebar: {
        bgClass: "bg-gradient-to-b from-cyan-950 via-sky-900 to-indigo-950",
        borderClass: "border-white/10",
        sectionClass: "text-cyan-300/70",
        activeClass: "bg-white text-cyan-950 shadow-lg",
        inactiveClass: "text-cyan-50 hover:bg-white/10 hover:text-white",
        footerClass: "text-cyan-200/70",
      },
      layout: {
        appBgClass: "bg-[radial-gradient(circle_at_top,_rgba(34,211,238,0.16),_transparent_35%),linear-gradient(180deg,_#ecfeff_0%,_#f8fafc_45%,_#eef2ff_100%)]",
        mainBgClass: "bg-transparent",
      },
      topbar: {
        headerClass: "bg-white/80 border-cyan-100",
        badgeClass: "bg-cyan-100 text-cyan-900 border-cyan-200",
        searchIdleClass: "bg-slate-100 text-slate-500",
        searchActiveClass: "bg-cyan-50 text-cyan-700",
        searchRingClass: "border-cyan-300 shadow-[0_0_0_4px_rgba(34,211,238,0.14)]",
      },
      stock: {
        heroBadge: "Service Desk",
        heroTitle: "Catalogue de services",
        heroSubtitle: "Structurez vos prestations, affichez les prix ou devis et gardez un suivi propre des offres visibles sur votre site service.",
        heroClass: "from-cyan-900 via-sky-700 to-indigo-800",
        heroGlowClass: "bg-cyan-300/20",
        buttonClass: "bg-cyan-400 text-slate-950 hover:bg-cyan-300",
        secondaryButtonClass: "border-cyan-200 bg-cyan-50 text-cyan-800 hover:bg-cyan-100",
        panelClass: "border-cyan-100 bg-white/95",
        panelMutedClass: "bg-gradient-to-br from-cyan-50 to-white",
        alertClass: "from-cyan-500 via-sky-500 to-indigo-500",
        availableStatusClass: "bg-cyan-50 text-cyan-800 border-cyan-200",
        lowStatusClass: "bg-amber-50 text-amber-700 border-amber-200",
        progressClass: "bg-cyan-500",
      },
    }
  }

  if (category === "FASHION") {
    return {
      ...shared,
      kind: "fashion" as ExperienceKind,
      category,
      name: "Mode",
      badge: "Mode Studio",
      inventorySingular: "article",
      inventoryPlural: "articles",
      stockSectionLabel: "Collection",
      salesSectionLabel: "Ventes & Style",
      clientsSectionLabel: "Clients & prospects",
      searchPlaceholder: "Rechercher article, taille, pointure, couleur…",
      sidebar: {
        bgClass: "bg-gradient-to-b from-fuchsia-950 via-purple-900 to-rose-950",
        borderClass: "border-white/10",
        sectionClass: "text-fuchsia-300/70",
        activeClass: "bg-white text-fuchsia-950 shadow-lg",
        inactiveClass: "text-fuchsia-50 hover:bg-white/10 hover:text-white",
        footerClass: "text-fuchsia-200/70",
      },
      layout: {
        appBgClass: "bg-[radial-gradient(circle_at_top,_rgba(217,70,239,0.18),_transparent_35%),linear-gradient(180deg,_#fdf4ff_0%,_#f8fafc_50%,_#fff1f2_100%)]",
        mainBgClass: "bg-transparent",
      },
      topbar: {
        headerClass: "bg-white/80 border-fuchsia-100",
        badgeClass: "bg-fuchsia-100 text-fuchsia-900 border-fuchsia-200",
        searchIdleClass: "bg-fuchsia-100 text-fuchsia-500",
        searchActiveClass: "bg-fuchsia-50 text-fuchsia-700",
        searchRingClass: "border-fuchsia-300 shadow-[0_0_0_4px_rgba(217,70,239,0.14)]",
      },
      stock: {
        heroBadge: "Mode Studio",
        heroTitle: "Votre collection",
        heroSubtitle:
          "Gérez vos articles, tailles, pointures et couleurs depuis une boutique pensée pour la mode.",
        heroClass: "from-fuchsia-950 via-purple-800 to-rose-600",
        heroGlowClass: "bg-fuchsia-300/25",
        buttonClass: "bg-white text-fuchsia-700 hover:bg-fuchsia-50",
        secondaryButtonClass: "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-800 hover:bg-fuchsia-100",
        panelClass: "border-fuchsia-100 bg-white",
        panelMutedClass: "bg-gradient-to-br from-fuchsia-50 to-white",
        alertClass: "from-fuchsia-600 via-purple-600 to-rose-600",
        availableStatusClass: "bg-fuchsia-50 text-fuchsia-800 border-fuchsia-200",
        lowStatusClass: "bg-rose-50 text-rose-700 border-rose-200",
        progressClass: "bg-fuchsia-600",
      },
    }
  }

  return {
    ...shared,
    kind: "general" as ExperienceKind,
    category,
    name: "General",
    badge: "Inventory Hub",
    inventorySingular: "produit",
    inventoryPlural: "produits",
    stockSectionLabel: "Stock",
    salesSectionLabel: "Ventes & Clients",
    clientsSectionLabel: "Clients",
    searchPlaceholder: "Rechercher produit, client, vente…",
    sidebar: {
      bgClass: "bg-blue-900",
      borderClass: "border-blue-800",
      sectionClass: "text-blue-400",
      activeClass: "bg-blue-700 text-white shadow",
      inactiveClass: "text-blue-100 hover:bg-blue-800 hover:text-white",
      footerClass: "text-blue-300",
    },
    layout: {
      appBgClass: "bg-slate-100",
      mainBgClass: "bg-gray-100",
    },
    topbar: {
      headerClass: "bg-white/80 border-gray-200",
      badgeClass: "bg-blue-100 text-blue-800 border-blue-200",
      searchIdleClass: "bg-gray-100 text-gray-500",
      searchActiveClass: "bg-blue-50 text-blue-600",
      searchRingClass: "border-blue-400 shadow-[0_0_0_4px_rgba(59,130,246,0.12)]",
    },
    stock: {
      heroBadge: "Inventory Hub",
      heroTitle: "Stock disponible",
      heroSubtitle: "Vue globale du stock, alertes faibles quantites et suivi par modele.",
      heroClass: "from-sky-600 via-blue-700 to-blue-900",
      heroGlowClass: "bg-cyan-300/25",
      buttonClass: "bg-white text-blue-700 hover:bg-blue-50",
      secondaryButtonClass: "border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100",
      panelClass: "border-slate-200 bg-white",
      panelMutedClass: "bg-gradient-to-br from-slate-50 to-white",
      alertClass: "from-sky-600 via-blue-700 to-blue-900",
      availableStatusClass: "bg-green-50 text-green-700 border-green-200",
      lowStatusClass: "bg-orange-50 text-orange-700 border-orange-200",
      progressClass: "bg-blue-600",
    },
  }
}
